// @ts-strict-ignore
import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

@Directive({
	selector: "[appBusy]",
	standalone: true,
})
export class BusyDirective implements OnInit, OnChanges {
	@Input("appBusy") promiseOrPromisesOrBoolean: Promise<unknown> | Promise<unknown>[] | boolean | undefined;
	@Input() busyOption: "busy" | "disabled" | "disable-class" | "inactive" = "busy";

	constructor(private elRef: ElementRef) {}

	public async ngOnChanges(changes: SimpleChanges) {
		await this.handlePromise();
	}

	public async ngOnInit() {
		await this.handlePromise();
	}

	private async handlePromise() {
		const $element = $(this.elRef.nativeElement);
		if (this.promiseOrPromisesOrBoolean == null) {
			return;
		}

		try {
			if (this.promiseOrPromisesOrBoolean instanceof Array) {
				$element.addClass(this.busyOption);
				await Promise.all(this.promiseOrPromisesOrBoolean);
				$element.removeClass(this.busyOption);
			} else if (this.promiseOrPromisesOrBoolean instanceof Promise) {
				$element.addClass(this.busyOption);
				await this.promiseOrPromisesOrBoolean;
				$element.removeClass(this.busyOption);
			} else if (typeof this.promiseOrPromisesOrBoolean === "boolean") {
				if (this.promiseOrPromisesOrBoolean) {
					$element.addClass(this.busyOption);
				} else {
					$element.removeClass(this.busyOption);
				}
			}
		} catch (_) {
			$element.removeClass(this.busyOption);
		}
	}
}
